/* eslint-disable no-new */
import './stream_login_page.scss';

import '../../../common/privacy/privacy';
import {
  hubEventLoadDispatch,
  sharedHubEventsInit,
} from '../../../common/hub_events/shared_hub_events';
import AuthenticationComponent from '../../../common/authentication/authentication';

const main = () => {
  sharedHubEventsInit();
  new AuthenticationComponent({
    streamId: document.body.dataset.streamId || -1,
    type: 'stream',
  });
  hubEventLoadDispatch();
};

document.addEventListener('DOMContentLoaded', main);
